import { guestRoutes } from 'mycorems-app-accounts';
import GuestLayout from '../../layout/GuestLayout.vue';
import router from '../../routing/router';

router.addRoutes([
  {
    path: '/',
    component: GuestLayout,
    children: guestRoutes,
  },
]);
